module.exports = __webpack_public_path__ + "img/Docs1.1f0e89de.jpg";